import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import TourGuide from '../../../components/TourGuide'
import { getTourSteps } from './tourSteps'
import { MoonLoader } from 'react-spinners'

interface LocationState {
  tourId: 'locationSettings' | 'clientCreation' | 'uploadClients'
}

interface TourData {
  title: string
  steps: Array<{
    title: string
    text: string
    image: string
    index: number
  }>
}

const HowTo = () => {
  const location = useLocation()
  const state = location.state as LocationState
  const [tourData, setTourData] = useState<TourData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchTourSteps = async () => {
      try {
        if (!state?.tourId) {
          setError('Invalid tour selection.')
          return
        }

        const tourStepsData = await getTourSteps(state.tourId)
        setTourData(tourStepsData)
      } catch (err) {
        console.error('Error fetching tour steps:', err)
        setError('Failed to load tour guide.')
      } finally {
        setLoading(false)
      }
    }

    fetchTourSteps()
  }, [state?.tourId])

  if (loading) {
    return (
      <div className='card card-body d-flex justify-content-center align-items-center' style={{ minHeight: '300px' }}>
        <MoonLoader color='#9db2fc' size={80} />
      </div>
    )
  }

  if (error || !tourData) {
    return (
      <div className='card card-body'>
        <p>{error || 'Invalid tour selection.'}</p>
      </div>
    )
  }

  return (
    <div className='card card-body'>
      <h1 className='mb-5 p-3'>{tourData.title}</h1>
      <TourGuide steps={tourData.steps} />
    </div>
  )
}

export default HowTo